import React from 'react';

type ChoosePlanHeaderProps = {
  description?: string;
};

const ChoosePlanHeader = ({ description }: ChoosePlanHeaderProps) => {
  return (
    <div className="mb-24 text-center">
      <h1 className="text-headline-md xs:text-headline-lg mt-0 mb-4 font-serif">
        Choose the plan that’s right for you
      </h1>
      <h3 className="text-body-sm xs:text-[16px] font-bold m-0 font-sans">
        {description ||
          'Join high-powered tech and business leaders who read The Information every day.'}
      </h3>
    </div>
  );
};

export default ChoosePlanHeader;
